import { cn } from '@/lib/utils';
import type { SiteVisitStatus } from '@/hooks/useSiteVisits';

const STATUS_CONFIG: Record<SiteVisitStatus, { label: string; className: string }> = {
  draft:       { label: 'Draft',       className: 'bg-gray-100 text-gray-700' },
  in_progress: { label: 'In Progress', className: 'bg-blue-100 text-blue-700' },
  completed:   { label: 'Completed',   className: 'bg-green-100 text-green-700' },
  submitted:   { label: 'Submitted',   className: 'bg-purple-100 text-purple-700' },
};

interface Props {
  status: SiteVisitStatus;
  className?: string;
}

export function SiteVisitStatusBadge({ status, className }: Props) {
  const config = STATUS_CONFIG[status] ?? { label: status, className: 'bg-gray-100 text-gray-600' };
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium', config.className, className)}>
      {config.label}
    </span>
  );
}
